// src/site_demobase/AIAssistant.tsx
import React, { useEffect } from "react";
import AITabs from "./AITabs";
import { useTranslation } from "react-i18next";

import CustomDropdown from "../../components/CustomDropdown";
import { SessionContext } from "../../types/sessionContext";

interface AIAssistantProps {
    currentStep: number;
    sessionContext: SessionContext;
    updateSessionContext: (newCtx: SessionContext) => void; // no functional form
}

const LANGUAGES = [
    { code: "en", label: "English", flag: "🇬🇧" },
    { code: "es", label: "Español", flag: "🇪🇸" },
    { code: "fr", label: "Français", flag: "🇫🇷" }
];

const AIAssistant: React.FC<AIAssistantProps> = ({ currentStep, sessionContext, updateSessionContext }) => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        const updatePrompt = async () => {
            try {
                const response = await fetch(`/updateprompt?step=p2_${currentStep}`);
                if (!response.ok) {
                    console.error("Failed to update prompt");
                }
            } catch (error) {
                console.error("Error updating prompt:", error);
            }
        };
        updatePrompt();
    }, [currentStep]);

    function handleLanguageChange(code: string) {
        i18n.changeLanguage(code);
    }

    return (
        <div className="flex h-full min-h-0 flex-col overflow-hidden">
            <h2 className="mb-4 text-xl font-semibold">{t("p2_demo.aiAssistant.title")}</h2>
            <CustomDropdown languages={LANGUAGES} selectedCode={i18n.language} onSelect={handleLanguageChange} />
            <AITabs currentStep={currentStep} sessionContext={sessionContext} updateSessionContext={updateSessionContext} />
            <button className="call-button rounded bg-blue-600 px-4 py-2 text-white transition hover:bg-blue-700">Start conversation</button>
        </div>
    );
};

export default AIAssistant;
